var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 300,
    viewBox: "0 0 380 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_338_676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178.231 135.964C178.552 135.643 178.941 135.482 179.393 135.482C179.845 135.482 180.229 135.643 180.555 135.964C180.876 136.284 181.036 136.673 181.036 137.125C181.036 137.578 180.876 137.962 180.555 138.287C180.234 138.608 179.845 138.769 179.393 138.769C178.941 138.769 178.557 138.608 178.231 138.287C177.911 137.966 177.75 137.578 177.75 137.125C177.75 136.673 177.911 136.289 178.231 135.964ZM178.149 145.71C178.115 144.646 178.047 143.654 177.94 142.73C178.542 142.837 179.024 142.891 179.388 142.891C179.753 142.891 180.239 142.837 180.837 142.73C180.73 143.654 180.662 144.646 180.628 145.71C180.594 146.775 180.579 147.786 180.579 148.753V152.102C180.579 153.07 180.594 154.086 180.628 155.146C180.662 156.21 180.73 157.173 180.837 158.028C180.341 157.984 179.86 157.965 179.388 157.965C178.917 157.965 178.431 157.984 177.94 158.028C178.047 157.168 178.115 156.205 178.149 155.146C178.183 154.081 178.197 153.065 178.197 152.102V148.753C178.197 147.786 178.183 146.77 178.149 145.71Z",
    fill: "#1D2958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.887 145.321C195.265 144.495 194.404 144.081 193.31 144.081C191.808 144.081 190.705 144.543 190.01 145.467C189.31 146.39 188.965 147.688 188.965 149.365V152.102C188.965 153.07 188.979 154.085 189.013 155.145C189.047 156.21 189.115 157.172 189.222 158.028C188.726 157.984 188.245 157.965 187.774 157.965C187.302 157.965 186.816 157.984 186.325 158.028C186.432 157.167 186.5 156.205 186.534 155.145C186.568 154.081 186.583 153.065 186.583 152.102V148.753C186.583 147.786 186.568 146.77 186.534 145.71C186.5 144.645 186.432 143.654 186.325 142.73C186.928 142.837 187.409 142.89 187.774 142.89C187.944 142.89 188.133 142.876 188.338 142.842C188.542 142.808 188.785 142.774 189.062 142.73C188.999 143.59 188.965 144.451 188.965 145.306H189.028C189.631 144.383 190.355 143.668 191.196 143.163C192.037 142.657 193.038 142.404 194.2 142.404C194.803 142.404 195.41 142.492 196.028 142.662C196.64 142.832 197.194 143.129 197.69 143.547C198.186 143.965 198.59 144.533 198.901 145.253C199.212 145.972 199.367 146.891 199.367 148.009C199.367 148.933 199.348 149.886 199.304 150.863C199.26 151.84 199.241 152.875 199.241 153.974V156.069C199.241 156.414 199.241 156.749 199.256 157.085C199.265 157.42 199.28 157.736 199.304 158.038C198.872 157.994 198.415 157.974 197.933 157.974C197.452 157.974 197.029 157.994 196.597 158.038C196.64 156.919 196.689 155.772 196.742 154.591C196.796 153.41 196.825 152.195 196.825 150.95V148.986C196.825 147.377 196.514 146.157 195.892 145.331L195.887 145.321Z",
    fill: "#1D2958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.8 145.321C213.178 144.495 212.317 144.081 211.224 144.081C209.721 144.081 208.618 144.543 207.923 145.467C207.223 146.39 206.878 147.688 206.878 149.365V152.102C206.878 153.07 206.892 154.085 206.926 155.145C206.96 156.205 207.028 157.172 207.135 158.028C206.64 157.984 206.158 157.965 205.687 157.965C205.215 157.965 204.729 157.984 204.238 158.028C204.345 157.167 204.418 156.205 204.447 155.145C204.481 154.081 204.496 153.065 204.496 152.102V148.753C204.496 147.786 204.481 146.77 204.447 145.71C204.413 144.645 204.345 143.654 204.238 142.73C204.841 142.837 205.322 142.89 205.687 142.89C205.857 142.89 206.046 142.876 206.251 142.842C206.455 142.808 206.698 142.774 206.975 142.73C206.912 143.59 206.878 144.451 206.878 145.306H206.941C207.544 144.383 208.268 143.668 209.104 143.163C209.945 142.657 210.946 142.404 212.108 142.404C212.711 142.404 213.319 142.492 213.936 142.662C214.549 142.832 215.103 143.129 215.599 143.547C216.094 143.965 216.498 144.533 216.809 145.253C217.12 145.972 217.276 146.891 217.276 148.009C217.276 148.933 217.256 149.886 217.212 150.863C217.169 151.84 217.149 152.875 217.149 153.974V156.069C217.149 156.414 217.154 156.749 217.164 157.085C217.174 157.42 217.188 157.736 217.212 158.038C216.78 157.994 216.323 157.974 215.842 157.974C215.36 157.974 214.937 157.994 214.505 158.038C214.549 156.919 214.597 155.772 214.651 154.591C214.704 153.41 214.733 152.195 214.733 150.95V148.986C214.733 147.377 214.422 146.157 213.8 145.331V145.321Z",
    fill: "#1D2958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.519 146.707C221.981 145.687 222.589 144.86 223.342 144.228C224.096 143.596 224.937 143.134 225.87 142.843C226.803 142.551 227.732 142.41 228.655 142.41C229.579 142.41 230.537 142.556 231.46 142.843C232.384 143.134 233.22 143.596 233.973 144.228C234.727 144.86 235.33 145.691 235.796 146.707C236.258 147.728 236.487 148.968 236.487 150.431C236.487 151.894 236.258 153.134 235.796 154.155C235.335 155.175 234.727 156.002 233.973 156.634C233.22 157.266 232.384 157.713 231.46 157.97C230.537 158.228 229.603 158.355 228.655 158.355C227.708 158.355 226.803 158.228 225.87 157.97C224.937 157.713 224.091 157.266 223.342 156.634C222.589 156.002 221.981 155.175 221.519 154.155C221.058 153.134 220.829 151.894 220.829 150.431C220.829 148.968 221.058 147.728 221.519 146.707ZM223.901 153.036C224.062 153.873 224.339 154.621 224.723 155.277C225.112 155.934 225.627 156.454 226.269 156.838C226.915 157.227 227.708 157.416 228.651 157.416C229.594 157.416 230.391 157.222 231.037 156.838C231.684 156.454 232.199 155.929 232.583 155.277C232.967 154.621 233.244 153.877 233.405 153.036C233.565 152.2 233.648 151.33 233.648 150.426C233.648 149.522 233.565 148.652 233.405 147.816C233.244 146.98 232.967 146.231 232.583 145.575C232.194 144.918 231.679 144.398 231.037 144.014C230.391 143.63 229.598 143.436 228.651 143.436C227.703 143.436 226.91 143.63 226.269 144.014C225.622 144.403 225.107 144.923 224.723 145.575C224.339 146.231 224.062 146.975 223.901 147.816C223.741 148.652 223.658 149.522 223.658 150.426C223.658 151.33 223.741 152.2 223.901 153.036Z",
    fill: "#1D2958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.173 150.43C240.176 147.898 239.082 145.331 237.901 142.73C238.178 142.774 238.451 142.813 238.708 142.842C238.966 142.871 239.233 142.891 239.515 142.891C239.753 142.891 239.987 142.876 240.225 142.842C240.463 142.808 240.696 142.774 240.935 142.73C241.601 144.86 242.325 146.945 243.107 148.996C243.89 151.048 244.765 153.148 245.732 155.296C246.16 154.417 246.588 153.464 247.006 152.443C247.424 151.422 247.842 150.362 248.26 149.269C248.678 148.175 249.087 147.071 249.485 145.968C249.884 144.86 250.273 143.78 250.662 142.73C251.046 142.837 251.381 142.891 251.658 142.891C251.935 142.891 252.271 142.837 252.655 142.73C251.493 145.331 250.355 147.898 249.237 150.43C248.119 152.963 247.098 155.501 246.175 158.033C245.854 157.989 245.519 157.97 245.178 157.97C244.838 157.97 244.493 157.989 244.148 158.033C243.161 155.501 242.164 152.963 241.168 150.43H241.173Z",
    fill: "#1D2958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.977 142.793C258.794 142.536 259.63 142.404 260.491 142.404C261.264 142.404 261.973 142.516 262.62 142.745C263.266 142.968 263.816 143.294 264.273 143.712C264.73 144.13 265.089 144.636 265.352 145.229C265.614 145.822 265.746 146.468 265.746 147.178C265.746 148.403 265.726 149.623 265.682 150.833C265.639 152.049 265.619 153.332 265.619 154.683C265.619 154.941 265.624 155.213 265.634 155.505C265.643 155.797 265.692 156.054 265.78 156.278C265.867 156.501 265.989 156.691 266.149 156.842C266.309 156.992 266.552 157.065 266.873 157.065C266.98 157.065 267.092 157.06 267.214 157.051C267.33 157.041 267.442 157.002 267.554 156.939V157.649C267.316 157.756 267.024 157.843 266.669 157.906C266.314 157.969 265.921 158.004 265.493 158.004C264.793 158.004 264.263 157.829 263.889 157.474C263.519 157.119 263.3 156.662 263.237 156.103C262.464 156.876 261.706 157.444 260.957 157.809C260.209 158.174 259.29 158.358 258.196 158.358C257.662 158.358 257.137 158.281 256.621 158.135C256.106 157.984 255.654 157.736 255.255 157.396C254.857 157.051 254.536 156.638 254.293 156.156C254.045 155.675 253.923 155.121 253.923 154.499C253.923 153.21 254.327 152.209 255.129 151.504C255.931 150.795 257.039 150.323 258.454 150.085C259.611 149.89 260.515 149.725 261.166 149.584C261.818 149.443 262.299 149.297 262.61 149.151C262.921 149.001 263.106 148.826 263.174 148.622C263.237 148.417 263.271 148.155 263.271 147.834C263.271 147.299 263.208 146.784 263.077 146.288C262.95 145.792 262.741 145.365 262.464 145C262.182 144.636 261.818 144.339 261.371 144.115C260.918 143.892 260.374 143.775 259.727 143.775C258.867 143.775 258.07 143.97 257.326 144.354C256.582 144.738 256.033 145.277 255.668 145.963H255.314V144.286C256.281 143.556 257.171 143.061 257.987 142.803L257.977 142.793ZM261.993 150.333C261.511 150.42 261.025 150.513 260.534 150.605C260.043 150.702 259.557 150.824 259.076 150.974C258.595 151.125 258.167 151.329 257.793 151.587C257.418 151.845 257.122 152.165 256.893 152.554C256.67 152.943 256.558 153.434 256.558 154.037C256.558 155.048 256.845 155.811 257.423 156.326C258.002 156.842 258.643 157.099 259.348 157.099C260.16 157.099 260.904 156.876 261.575 156.424C262.246 155.972 262.766 155.447 263.13 154.844L263.257 150.012C262.892 150.138 262.469 150.25 261.988 150.333H261.993Z",
    fill: "#1D2958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.053 138.414C273.99 139.231 273.941 140.033 273.907 140.815C273.873 141.598 273.839 142.39 273.795 143.183C274.034 143.183 274.471 143.178 275.118 143.168C275.764 143.158 276.459 143.129 277.213 143.086C277.193 143.149 277.179 143.27 277.179 143.44V144.116C277.179 144.267 277.188 144.374 277.213 144.437C276.936 144.418 276.644 144.398 276.343 144.388C276.041 144.379 275.72 144.374 275.375 144.374H273.795C273.776 144.461 273.747 144.802 273.713 145.404C273.679 146.007 273.654 146.722 273.63 147.548C273.611 148.374 273.591 149.24 273.582 150.144C273.572 151.048 273.567 151.85 273.567 152.56C273.567 153.163 273.582 153.751 273.616 154.334C273.65 154.913 273.752 155.438 273.922 155.895C274.092 156.356 274.35 156.726 274.695 157.008C275.04 157.285 275.531 157.426 276.177 157.426C276.348 157.426 276.581 157.406 276.868 157.363C277.159 157.319 277.412 157.265 277.626 157.202V157.975C277.261 158.038 276.858 158.121 276.416 158.218C275.973 158.315 275.55 158.364 275.142 158.364C273.791 158.364 272.789 158.029 272.148 157.367C271.501 156.701 271.18 155.724 271.18 154.436C271.18 153.858 271.19 153.226 271.214 152.55C271.234 151.874 271.263 151.131 271.297 150.329C271.331 149.522 271.355 148.632 271.375 147.655C271.394 146.678 271.409 145.589 271.409 144.383H270.378C270.208 144.383 270.023 144.388 269.829 144.398C269.634 144.408 269.43 144.427 269.216 144.447C269.236 144.315 269.255 144.194 269.265 144.077C269.275 143.961 269.279 143.834 269.279 143.708C269.279 143.601 269.275 143.494 269.265 143.387C269.255 143.28 269.236 143.173 269.216 143.066C270.184 143.129 270.893 143.163 271.341 143.163C271.321 142.736 271.302 142.196 271.292 141.554C271.282 140.908 271.253 140.247 271.209 139.556L273.883 138.429H274.043L274.053 138.414Z",
    fill: "#1D2958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.946 135.964C281.267 135.643 281.656 135.482 282.108 135.482C282.56 135.482 282.944 135.643 283.27 135.964C283.591 136.284 283.751 136.673 283.751 137.125C283.751 137.578 283.591 137.962 283.27 138.287C282.949 138.608 282.56 138.769 282.108 138.769C281.656 138.769 281.272 138.608 280.946 138.287C280.625 137.966 280.465 137.578 280.465 137.125C280.465 136.673 280.625 136.289 280.946 135.964ZM280.863 145.71C280.829 144.646 280.761 143.654 280.654 142.73C281.257 142.837 281.738 142.891 282.103 142.891C282.468 142.891 282.954 142.837 283.552 142.73C283.445 143.654 283.372 144.646 283.343 145.71C283.309 146.775 283.294 147.786 283.294 148.753V152.102C283.294 153.07 283.309 154.086 283.343 155.146C283.377 156.21 283.445 157.173 283.552 158.028C283.056 157.984 282.575 157.965 282.103 157.965C281.632 157.965 281.145 157.984 280.654 158.028C280.761 157.168 280.829 156.205 280.863 155.146C280.897 154.086 280.912 153.065 280.912 152.102V148.753C280.912 147.786 280.897 146.77 280.863 145.71Z",
    fill: "#1D2958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.408 146.707C288.87 145.687 289.477 144.86 290.231 144.228C290.984 143.596 291.825 143.134 292.759 142.843C293.692 142.551 294.62 142.41 295.544 142.41C296.468 142.41 297.425 142.556 298.349 142.843C299.272 143.134 300.109 143.596 300.862 144.228C301.615 144.86 302.218 145.691 302.685 146.707C303.147 147.728 303.375 148.968 303.375 150.431C303.375 151.894 303.147 153.134 302.685 154.155C302.223 155.175 301.615 156.002 300.862 156.634C300.109 157.266 299.272 157.713 298.349 157.97C297.425 158.228 296.492 158.355 295.544 158.355C294.596 158.355 293.692 158.228 292.759 157.97C291.825 157.713 290.979 157.266 290.231 156.634C289.477 156.002 288.87 155.175 288.408 154.155C287.946 153.134 287.718 151.894 287.718 150.431C287.718 148.968 287.946 147.728 288.408 146.707ZM290.79 153.036C290.95 153.873 291.227 154.621 291.611 155.277C292 155.934 292.516 156.454 293.157 156.838C293.804 157.227 294.596 157.416 295.539 157.416C296.482 157.416 297.279 157.222 297.926 156.838C298.572 156.454 299.088 155.929 299.472 155.277C299.856 154.621 300.133 153.877 300.293 153.036C300.454 152.2 300.536 151.33 300.536 150.426C300.536 149.522 300.454 148.652 300.293 147.816C300.133 146.98 299.856 146.231 299.472 145.575C299.083 144.918 298.568 144.398 297.926 144.014C297.279 143.63 296.487 143.436 295.539 143.436C294.591 143.436 293.799 143.63 293.157 144.014C292.511 144.403 291.995 144.923 291.611 145.575C291.227 146.231 290.95 146.975 290.79 147.816C290.629 148.652 290.547 149.522 290.547 150.426C290.547 151.33 290.629 152.2 290.79 153.036Z",
    fill: "#1D2958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.52 145.321C315.897 144.495 315.037 144.081 313.943 144.081C312.441 144.081 311.338 144.543 310.642 145.467C309.942 146.39 309.597 147.688 309.597 149.365V152.102C309.597 153.07 309.612 154.085 309.646 155.145C309.68 156.205 309.748 157.172 309.855 158.028C309.359 157.984 308.878 157.965 308.406 157.965C307.935 157.965 307.449 157.984 306.958 158.028C307.065 157.167 307.138 156.205 307.167 155.145C307.201 154.081 307.215 153.065 307.215 152.102V148.753C307.215 147.786 307.201 146.77 307.167 145.71C307.133 144.645 307.065 143.654 306.958 142.73C307.561 142.837 308.042 142.89 308.406 142.89C308.577 142.89 308.766 142.876 308.97 142.842C309.174 142.808 309.417 142.774 309.695 142.73C309.631 143.59 309.597 144.451 309.597 145.306H309.661C310.263 144.383 310.988 143.668 311.824 143.163C312.665 142.657 313.666 142.404 314.828 142.404C315.431 142.404 316.038 142.492 316.656 142.662C317.268 142.832 317.822 143.129 318.318 143.547C318.814 143.965 319.217 144.533 319.529 145.253C319.84 145.972 319.995 146.891 319.995 148.009C319.995 148.933 319.976 149.886 319.932 150.863C319.888 151.84 319.869 152.875 319.869 153.974V156.069C319.869 156.414 319.874 156.749 319.883 157.085C319.893 157.42 319.908 157.736 319.932 158.038C319.499 157.994 319.042 157.974 318.561 157.974C318.08 157.974 317.657 157.994 317.224 158.038C317.268 156.919 317.317 155.772 317.37 154.591C317.424 153.41 317.453 152.195 317.453 150.95V148.986C317.453 147.377 317.142 146.157 316.52 145.331V145.321Z",
    fill: "#1D2958"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.25 126.417C188.08 126.762 187.847 127.131 187.56 127.53C187.268 127.929 186.904 128.298 186.466 128.643C186.024 128.988 185.504 129.265 184.906 129.479C184.303 129.693 183.608 129.8 182.81 129.8C182.013 129.8 181.192 129.659 180.409 129.382C179.626 129.105 178.926 128.648 178.314 128.011C177.701 127.379 177.206 126.563 176.831 125.561C176.457 124.565 176.267 123.364 176.267 121.969C176.267 120.574 176.472 119.402 176.88 118.391C177.288 117.38 177.818 116.539 178.474 115.863C179.131 115.188 179.87 114.682 180.696 114.347C181.522 114.016 182.354 113.846 183.195 113.846C185.576 113.846 187.234 114.92 188.158 117.069H188.221V113.909C188.221 113.093 188.216 112.271 188.206 111.445C188.197 110.618 188.187 109.831 188.172 109.077C188.163 108.324 188.153 107.619 188.138 106.948C188.129 106.282 188.109 105.694 188.09 105.174C188.347 105.218 188.595 105.256 188.828 105.286C189.067 105.32 189.3 105.334 189.538 105.334C189.776 105.334 190.005 105.32 190.233 105.286C190.457 105.252 190.71 105.218 190.992 105.174C190.928 105.864 190.875 106.856 190.831 108.154C190.788 109.452 190.749 110.886 190.719 112.456C190.685 114.026 190.661 115.635 190.642 117.288C190.622 118.94 190.608 120.457 190.608 121.833C190.608 123.315 190.617 124.647 190.642 125.829C190.661 127.01 190.685 128.225 190.705 129.47C190.277 129.426 189.854 129.406 189.451 129.406C189.062 129.406 188.654 129.426 188.226 129.47L188.323 126.407H188.26L188.25 126.417ZM179.5 125.352C179.767 126.188 180.113 126.859 180.531 127.365C180.949 127.87 181.425 128.22 181.965 128.41C182.499 128.604 183.029 128.701 183.545 128.701C184.381 128.701 185.1 128.492 185.703 128.074C186.306 127.656 186.801 127.107 187.2 126.431C187.599 125.756 187.885 124.988 188.07 124.127C188.25 123.267 188.342 122.406 188.342 121.551C188.342 119.49 187.944 117.915 187.151 116.831C186.354 115.747 185.188 115.202 183.642 115.202C182.869 115.202 182.198 115.382 181.629 115.732C181.06 116.087 180.589 116.583 180.21 117.215C179.835 117.847 179.554 118.59 179.374 119.436C179.189 120.287 179.101 121.191 179.101 122.158C179.101 123.447 179.238 124.511 179.505 125.347L179.5 125.352Z",
    fill: "#228BB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.838 116.107C197.092 114.605 198.925 113.852 201.331 113.852C202.469 113.852 203.451 114.027 204.282 114.381C205.108 114.736 205.799 115.208 206.358 115.801C206.917 116.394 207.33 117.084 207.597 117.881C207.864 118.674 208.001 119.524 208.001 120.429C208.001 120.643 207.996 120.852 207.986 121.056C207.976 121.26 207.957 121.469 207.937 121.683C206.776 121.663 205.628 121.639 204.491 121.62C203.353 121.6 202.201 121.586 201.044 121.586C200.335 121.586 199.63 121.595 198.935 121.62C198.235 121.644 197.535 121.663 196.825 121.683C196.806 121.79 196.791 121.95 196.791 122.164V122.582C196.791 123.418 196.912 124.206 197.16 124.935C197.408 125.664 197.768 126.291 198.24 126.821C198.711 127.346 199.29 127.769 199.98 128.08C200.665 128.391 201.462 128.547 202.362 128.547C202.789 128.547 203.232 128.488 203.684 128.372C204.136 128.255 204.574 128.095 205.006 127.89C205.434 127.686 205.837 127.443 206.217 127.166C206.591 126.889 206.921 126.588 207.199 126.262L207.359 126.359L207.164 127.939C206.518 128.454 205.721 128.897 204.763 129.261C203.805 129.626 202.814 129.811 201.783 129.811C200.621 129.811 199.567 129.636 198.609 129.281C197.651 128.926 196.825 128.411 196.13 127.735C195.43 127.059 194.895 126.257 194.521 125.333C194.146 124.41 193.957 123.413 193.957 122.339C193.957 119.699 194.584 117.624 195.843 116.122L195.838 116.107ZM199.382 115.431C198.833 115.796 198.385 116.253 198.031 116.802C197.676 117.352 197.408 117.949 197.224 118.606C197.039 119.262 196.927 119.879 196.883 120.458C197.549 120.477 198.24 120.502 198.964 120.521C199.683 120.54 200.388 120.555 201.074 120.555C201.759 120.555 202.503 120.545 203.232 120.521C203.961 120.502 204.671 120.477 205.356 120.458C205.356 119.879 205.308 119.267 205.21 118.62C205.113 117.974 204.919 117.376 204.632 116.817C204.34 116.258 203.942 115.796 203.421 115.431C202.906 115.067 202.23 114.882 201.389 114.882C200.549 114.882 199.921 115.067 199.377 115.431H199.382Z",
    fill: "#228BB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.955 116.768C220.333 115.942 219.473 115.529 218.379 115.529C216.877 115.529 215.774 115.99 215.078 116.914C214.378 117.838 214.033 119.136 214.033 120.813V123.549C214.033 124.517 214.048 125.533 214.082 126.592C214.116 127.652 214.184 128.62 214.291 129.475C213.795 129.431 213.314 129.412 212.842 129.412C212.371 129.412 211.885 129.431 211.394 129.475C211.501 128.615 211.574 127.652 211.603 126.592C211.637 125.528 211.651 124.512 211.651 123.549V120.2C211.651 119.233 211.637 118.217 211.603 117.157C211.569 116.093 211.501 115.101 211.394 114.177C211.996 114.284 212.478 114.338 212.842 114.338C213.012 114.338 213.202 114.323 213.406 114.289C213.61 114.255 213.853 114.221 214.13 114.177C214.067 115.038 214.033 115.898 214.033 116.754H214.096C214.699 115.83 215.424 115.115 216.26 114.61C217.096 114.104 218.102 113.852 219.264 113.852C219.867 113.852 220.474 113.939 221.092 114.109C221.704 114.279 222.258 114.576 222.754 114.994C223.25 115.412 223.653 115.981 223.964 116.7C224.276 117.42 224.431 118.338 224.431 119.456C224.431 120.38 224.412 121.333 224.368 122.31C224.324 123.287 224.305 124.322 224.305 125.421V127.516C224.305 127.861 224.31 128.197 224.319 128.532C224.329 128.867 224.344 129.183 224.368 129.485C223.935 129.441 223.478 129.422 222.997 129.422C222.516 129.422 222.093 129.441 221.66 129.485C221.704 128.367 221.753 127.22 221.806 126.038C221.86 124.857 221.889 123.642 221.889 122.397V120.433C221.889 118.824 221.578 117.604 220.955 116.778V116.768Z",
    fill: "#228BB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.167 107.409C230.488 107.088 230.877 106.928 231.329 106.928C231.781 106.928 232.165 107.088 232.491 107.409C232.812 107.73 232.972 108.119 232.972 108.571C232.972 109.023 232.812 109.407 232.491 109.733C232.17 110.053 231.781 110.214 231.329 110.214C230.877 110.214 230.493 110.053 230.167 109.733C229.846 109.412 229.686 109.023 229.686 108.571C229.686 108.119 229.846 107.735 230.167 107.409ZM230.085 117.155C230.05 116.091 229.982 115.099 229.875 114.176C230.478 114.283 230.96 114.336 231.324 114.336C231.689 114.336 232.175 114.283 232.773 114.176C232.666 115.099 232.593 116.091 232.564 117.155C232.53 118.22 232.515 119.231 232.515 120.198V123.548C232.515 124.515 232.53 125.531 232.564 126.591C232.598 127.655 232.666 128.618 232.773 129.473C232.277 129.43 231.796 129.41 231.324 129.41C230.853 129.41 230.366 129.43 229.875 129.473C229.982 128.613 230.05 127.651 230.085 126.591C230.119 125.531 230.133 124.51 230.133 123.548V120.198C230.133 119.231 230.119 118.215 230.085 117.155Z",
    fill: "#228BB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.271 117.156C238.237 116.092 238.168 115.1 238.062 114.176C238.664 114.283 239.146 114.337 239.51 114.337C239.68 114.337 239.87 114.322 240.074 114.288C240.278 114.254 240.521 114.22 240.798 114.176C240.735 115.037 240.701 115.897 240.701 116.753H240.764C241.897 114.818 243.496 113.855 245.548 113.855C246.082 113.855 246.607 113.933 247.123 114.099C247.638 114.259 248.1 114.483 248.518 114.76C248.936 115.042 249.296 115.377 249.592 115.776C249.893 116.174 250.093 116.597 250.2 117.049H250.263C250.778 116.019 251.483 115.226 252.377 114.682C253.272 114.133 254.302 113.86 255.464 113.86C256.174 113.86 256.835 113.958 257.438 114.152C258.041 114.346 258.561 114.648 259.003 115.056C259.445 115.464 259.791 115.989 260.039 116.636C260.286 117.283 260.408 118.055 260.408 118.955C260.408 119.319 260.398 119.718 260.374 120.146C260.354 120.573 260.33 121.074 260.311 121.643C260.291 122.212 260.267 122.858 260.248 123.578C260.228 124.297 260.214 125.128 260.214 126.076C260.214 126.655 260.218 127.214 260.228 127.753C260.238 128.288 260.267 128.871 260.311 129.494C260.073 129.45 259.839 129.43 259.601 129.43H258.216C257.977 129.43 257.744 129.45 257.506 129.494C257.569 128.959 257.642 127.87 257.715 126.242C257.788 124.608 257.827 122.333 257.827 119.412C257.827 118.877 257.768 118.371 257.647 117.895C257.53 117.424 257.341 117.015 257.078 116.67C256.82 116.325 256.475 116.053 256.043 115.849C255.61 115.644 255.07 115.542 254.424 115.542C253.646 115.542 252.99 115.693 252.45 115.994C251.911 116.296 251.493 116.651 251.186 117.059C251.011 117.297 250.88 117.53 250.783 117.769C250.686 118.007 250.608 118.367 250.555 118.848C250.501 119.329 250.462 120.01 250.443 120.88C250.423 121.75 250.409 122.946 250.409 124.472C250.409 125.396 250.423 126.237 250.457 127C250.491 127.763 250.525 128.594 250.569 129.498C250.083 129.455 249.616 129.435 249.169 129.435C248.722 129.435 248.255 129.455 247.769 129.498C247.866 128.317 247.93 127.112 247.968 125.892C248.007 124.667 248.027 123.466 248.027 122.285C248.027 121.273 248.022 120.486 248.012 119.917C248.002 119.348 247.973 118.896 247.93 118.566C247.886 118.235 247.827 117.958 247.755 117.744C247.682 117.53 247.58 117.292 247.448 117.035C247.215 116.626 246.846 116.276 246.34 115.989C245.839 115.698 245.319 115.557 244.784 115.557C243.375 115.557 242.334 116.019 241.673 116.942C241.012 117.866 240.682 119.164 240.682 120.841V123.578C240.682 124.545 240.696 125.561 240.73 126.621C240.764 127.685 240.832 128.648 240.939 129.503C240.443 129.46 239.962 129.44 239.491 129.44C239.019 129.44 238.533 129.46 238.042 129.503C238.149 128.643 238.217 127.68 238.251 126.621C238.285 125.561 238.3 124.54 238.3 123.578V120.228C238.3 119.261 238.285 118.245 238.251 117.185L238.271 117.156Z",
    fill: "#228BB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.928 174.688C186.306 173.862 185.445 173.449 184.351 173.449C182.849 173.449 181.746 173.91 181.051 174.834C180.351 175.758 180.006 177.055 180.006 178.733V181.469C180.006 182.437 180.02 183.453 180.054 184.512C180.088 185.577 180.156 186.539 180.263 187.395C179.767 187.351 179.286 187.332 178.815 187.332C178.343 187.332 177.857 187.351 177.366 187.395C177.473 186.535 177.541 185.572 177.575 184.512C177.609 183.448 177.624 182.432 177.624 181.469V178.12C177.624 177.153 177.609 176.137 177.575 175.077C177.541 174.012 177.473 173.021 177.366 172.097C177.969 172.204 178.45 172.258 178.815 172.258C178.985 172.258 179.174 172.243 179.379 172.209C179.583 172.175 179.826 172.141 180.103 172.097C180.04 172.958 180.006 173.818 180.006 174.674H180.069C180.672 173.75 181.396 173.035 182.232 172.53C183.073 172.024 184.074 171.771 185.236 171.771C185.839 171.771 186.447 171.859 187.064 172.029C187.681 172.199 188.231 172.496 188.726 172.914C189.222 173.332 189.626 173.901 189.937 174.62C190.248 175.34 190.404 176.258 190.404 177.376C190.404 178.3 190.384 179.253 190.34 180.23C190.297 181.207 190.277 182.242 190.277 183.341V185.436C190.277 185.781 190.282 186.117 190.292 186.452C190.301 186.787 190.316 187.103 190.34 187.405C189.908 187.361 189.451 187.342 188.969 187.342C188.488 187.342 188.065 187.361 187.633 187.405C187.676 186.287 187.725 185.139 187.779 183.958C187.832 182.777 187.861 181.562 187.861 180.317V178.353C187.861 176.744 187.55 175.524 186.928 174.698V174.688Z",
    fill: "#228BB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.144 165.327C196.465 165.006 196.854 164.846 197.306 164.846C197.758 164.846 198.142 165.006 198.468 165.327C198.789 165.648 198.949 166.037 198.949 166.489C198.949 166.941 198.789 167.325 198.468 167.651C198.147 167.971 197.758 168.132 197.306 168.132C196.854 168.132 196.47 167.971 196.144 167.651C195.824 167.33 195.663 166.941 195.663 166.489C195.663 166.037 195.824 165.653 196.144 165.327ZM196.062 175.073C196.028 174.009 195.96 173.017 195.853 172.094C196.456 172.201 196.937 172.254 197.301 172.254C197.666 172.254 198.152 172.201 198.75 172.094C198.643 173.017 198.57 174.009 198.541 175.073C198.507 176.138 198.492 177.149 198.492 178.116V181.466C198.492 182.433 198.507 183.449 198.541 184.509C198.575 185.569 198.643 186.536 198.75 187.391C198.254 187.348 197.773 187.328 197.301 187.328C196.83 187.328 196.344 187.348 195.853 187.391C195.96 186.531 196.028 185.569 196.062 184.509C196.096 183.449 196.11 182.428 196.11 181.466V178.116C196.11 177.149 196.096 176.133 196.062 175.073Z",
    fill: "#228BB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.878 174.688C204.199 174.032 204.647 173.492 205.215 173.06C205.784 172.632 206.44 172.306 207.179 172.092C207.918 171.878 208.71 171.771 209.547 171.771C209.955 171.771 210.349 171.781 210.723 171.806C211.097 171.825 211.578 171.859 212.157 171.903C212.653 171.946 213.09 171.981 213.479 172C213.863 172.019 214.179 172.034 214.412 172.034C215.613 172.034 216.483 171.981 217.023 171.874C217.003 171.981 216.984 172.092 216.974 172.214C216.965 172.331 216.96 172.447 216.96 172.554C216.96 172.661 216.96 172.773 216.974 172.894C216.984 173.011 216.999 173.128 217.023 173.235C216.401 173.191 215.793 173.142 215.2 173.089C214.607 173.035 214.024 172.996 213.445 172.977L213.382 173.04C214.048 173.405 214.583 173.969 214.991 174.732C215.399 175.495 215.603 176.283 215.603 177.099C215.603 178.708 215.059 179.972 213.975 180.886C212.891 181.8 211.433 182.257 209.61 182.257C209.308 182.257 209.012 182.247 208.725 182.223C208.433 182.203 208.142 182.189 207.84 182.189C207.456 182.189 207.092 182.33 206.761 182.607C206.426 182.884 206.26 183.239 206.26 183.671C206.26 184.23 206.397 184.639 206.664 184.896C206.931 185.154 207.432 185.295 208.161 185.314C208.764 185.334 209.352 185.353 209.935 185.363C210.514 185.373 211.107 185.392 211.71 185.412C212.696 185.431 213.542 185.553 214.237 185.767C214.933 185.98 215.506 186.272 215.944 186.637C216.386 187.001 216.707 187.419 216.911 187.896C217.115 188.367 217.217 188.883 217.217 189.442C217.217 190.195 217.071 190.958 216.785 191.731C216.493 192.504 216.041 193.204 215.433 193.826C214.821 194.448 214.033 194.964 213.066 195.372C212.099 195.78 210.942 195.985 209.585 195.985C207.5 195.985 205.857 195.571 204.656 194.745C203.451 193.919 202.853 192.786 202.853 191.347C202.853 190.788 202.955 190.273 203.159 189.801C203.363 189.33 203.626 188.912 203.947 188.547C204.267 188.183 204.632 187.891 205.04 187.677C205.449 187.463 205.867 187.303 206.294 187.196V187.133C205.628 186.938 205.123 186.617 204.778 186.165C204.433 185.713 204.262 185.178 204.262 184.556C204.262 184.192 204.331 183.856 204.472 183.56C204.613 183.258 204.788 182.991 205.001 182.753C205.215 182.514 205.463 182.325 205.74 182.174C206.017 182.024 206.29 181.926 206.547 181.883V181.819C205.56 181.392 204.788 180.784 204.228 179.996C203.669 179.214 203.392 178.232 203.392 177.051C203.392 176.146 203.553 175.369 203.874 174.712L203.878 174.688ZM213.708 188.11C212.954 187.594 211.71 187.337 209.969 187.337C208.36 187.337 207.111 187.599 206.231 188.124C205.351 188.649 204.909 189.602 204.909 190.978C204.909 191.707 205.031 192.329 205.278 192.844C205.526 193.36 205.857 193.778 206.275 194.098C206.693 194.419 207.194 194.657 207.772 194.808C208.351 194.959 208.973 195.032 209.639 195.032C210.305 195.032 210.917 194.944 211.54 194.774C212.162 194.604 212.716 194.346 213.197 194.001C213.678 193.656 214.072 193.223 214.374 192.698C214.675 192.173 214.826 191.542 214.826 190.812C214.826 189.524 214.451 188.62 213.698 188.105L213.708 188.11ZM212.128 173.769C211.481 173.06 210.635 172.705 209.581 172.705C208.419 172.705 207.519 173.099 206.873 173.881C206.226 174.664 205.906 175.714 205.906 177.021C205.906 178.329 206.202 179.442 206.79 180.225C207.378 181.008 208.297 181.401 209.547 181.401C210.169 181.401 210.703 181.28 211.141 181.032C211.583 180.784 211.948 180.453 212.235 180.035C212.526 179.617 212.74 179.131 212.881 178.587C213.022 178.037 213.09 177.464 213.09 176.861C213.09 175.51 212.769 174.474 212.123 173.769H212.128Z",
    fill: "#228BB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.581 169.997C220.571 169.137 220.552 168.291 220.533 167.45C220.513 166.614 220.484 165.812 220.45 165.049C220.416 164.286 220.382 163.639 220.338 163.1C220.941 163.207 221.422 163.26 221.787 163.26C222.151 163.26 222.633 163.207 223.235 163.1C223.192 163.639 223.153 164.281 223.124 165.034C223.09 165.788 223.065 166.575 223.046 167.402C223.026 168.228 223.007 169.059 222.997 169.9C222.987 170.736 222.983 171.509 222.983 172.219V174.669H223.046C223.649 173.745 224.373 173.031 225.209 172.525C226.05 172.02 227.051 171.767 228.213 171.767C228.816 171.767 229.423 171.854 230.041 172.025C230.653 172.195 231.208 172.491 231.703 172.909C232.199 173.327 232.603 173.896 232.914 174.616C233.225 175.335 233.38 176.254 233.38 177.372C233.38 178.295 233.361 179.248 233.317 180.225C233.273 181.202 233.254 182.238 233.254 183.336V185.431C233.254 185.777 233.259 186.112 233.269 186.447C233.278 186.783 233.293 187.099 233.317 187.4C232.885 187.356 232.428 187.337 231.946 187.337C231.465 187.337 231.042 187.356 230.61 187.4C230.653 186.282 230.702 185.135 230.755 183.954C230.809 182.772 230.838 181.557 230.838 180.313V178.349C230.838 176.74 230.527 175.52 229.905 174.693C229.283 173.867 228.422 173.454 227.328 173.454C225.826 173.454 224.723 173.916 224.028 174.839C223.328 175.763 222.983 177.061 222.983 178.738C222.983 179.34 222.983 180.036 222.997 180.833C223.007 181.625 223.021 182.427 223.046 183.234C223.065 184.041 223.094 184.819 223.124 185.572C223.158 186.326 223.192 186.938 223.235 187.41C222.74 187.366 222.258 187.347 221.787 187.347C221.315 187.347 220.829 187.366 220.338 187.41C220.382 186.914 220.421 186.292 220.45 185.543C220.484 184.79 220.508 183.997 220.533 183.161C220.552 182.325 220.571 181.475 220.581 180.614C220.591 179.754 220.596 178.961 220.596 178.227V172.394C220.596 171.665 220.591 170.868 220.581 170.012V169.997Z",
    fill: "#228BB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.187 167.775C241.124 168.592 241.075 169.394 241.041 170.177C241.007 170.959 240.973 171.752 240.93 172.544C241.168 172.544 241.605 172.539 242.252 172.53C242.898 172.52 243.593 172.491 244.347 172.447C244.328 172.51 244.313 172.632 244.313 172.802V173.477C244.313 173.628 244.323 173.735 244.347 173.798C244.07 173.779 243.778 173.759 243.477 173.75C243.175 173.74 242.855 173.735 242.509 173.735H240.93C240.91 173.823 240.881 174.163 240.847 174.766C240.813 175.368 240.789 176.083 240.764 176.909C240.745 177.736 240.725 178.601 240.716 179.505C240.706 180.409 240.701 181.211 240.701 181.921C240.701 182.524 240.716 183.112 240.75 183.695C240.784 184.274 240.886 184.799 241.056 185.256C241.226 185.718 241.484 186.087 241.829 186.369C242.174 186.646 242.665 186.787 243.312 186.787C243.482 186.787 243.715 186.768 244.002 186.724C244.293 186.68 244.546 186.627 244.76 186.563V187.336C244.396 187.4 243.992 187.482 243.55 187.579C243.107 187.677 242.684 187.725 242.276 187.725C240.925 187.725 239.923 187.39 239.282 186.729C238.635 186.063 238.314 185.086 238.314 183.798C238.314 183.219 238.324 182.587 238.348 181.911C238.368 181.236 238.397 180.492 238.431 179.69C238.465 178.883 238.489 177.993 238.509 177.016C238.528 176.039 238.543 174.95 238.543 173.745H237.512C237.342 173.745 237.157 173.75 236.963 173.759C236.769 173.769 236.564 173.789 236.35 173.808C236.37 173.677 236.389 173.555 236.399 173.439C236.409 173.322 236.414 173.196 236.414 173.069C236.414 172.962 236.409 172.855 236.399 172.748C236.389 172.641 236.37 172.534 236.35 172.427C237.318 172.491 238.028 172.525 238.475 172.525C238.455 172.097 238.436 171.557 238.426 170.916C238.416 170.269 238.387 169.608 238.344 168.918L241.017 167.79H241.178L241.187 167.775Z",
    fill: "#228BB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.385 157.996L143.679 179.171L147.417 171.938L117.385 157.996Z",
    fill: "url(#paint0_radial_338_676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.472 177.635L130.739 174.966L121.289 166.707L127.472 177.635Z",
    fill: "url(#paint1_radial_338_676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.963 198.727L132.129 196.719L117.006 169.75L127.963 198.727Z",
    fill: "url(#paint2_radial_338_676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.131 182.954L112.179 171.375L112.266 183.892L116.131 182.954Z",
    fill: "url(#paint3_radial_338_676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.792 188.781L109.617 189.141L107.366 171.869L102.792 188.781Z",
    fill: "url(#paint4_radial_338_676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.698 164.477L95.7095 181.554L100.789 183.391L104.698 164.477Z",
    fill: "url(#paint5_radial_338_676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2777 198.241L77.427 202.577L95.9429 169.988L71.2777 198.241Z",
    fill: "url(#paint6_radial_338_676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3554 174.854L93.3859 165.842L82.988 171.257L85.3554 174.854Z",
    fill: "url(#paint7_radial_338_676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0075 161.16L71.7444 166.901L74.7437 172.365L90.0075 161.16Z",
    fill: "url(#paint8_radial_338_676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.379 156.615L76.6735 156.64L77.8985 161.015L88.379 156.615Z",
    fill: "url(#paint9_radial_338_676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.234 146.238L63.3298 153.229L92.297 151.702L64.234 146.238Z",
    fill: "url(#paint10_radial_338_676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7095 145.377L79.5609 139.223L77.6262 143.617L88.7095 145.377Z",
    fill: "url(#paint11_radial_338_676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7388 120.551L62.1777 127.915L90.9262 140.943L67.7388 120.551Z",
    fill: "url(#paint12_radial_338_676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5624 124.916L83.9554 127.259L94.2609 136.806L87.5624 124.916Z",
    fill: "url(#paint13_radial_338_676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5054 98.6426L80.5575 102.22L99.1123 133.774L88.5054 98.6426Z",
    fill: "url(#paint14_radial_338_676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.921 120.402L104.051 132.093L105.767 120.246L100.921 120.402Z",
    fill: "url(#paint15_radial_338_676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.568 110.236L110.162 109.312L108.825 135.65L116.568 110.236Z",
    fill: "url(#paint16_radial_338_676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.439 132.7L121.58 122.739L116.515 120.984L114.439 132.7Z",
    fill: "url(#paint17_radial_338_676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4081 98.4382C89.4533 100.606 88.5442 103.212 86.3762 104.252C84.2081 105.297 81.6026 104.388 80.5575 102.22C79.5123 100.052 80.4214 97.4465 82.5894 96.4014C84.7574 95.3562 87.363 96.2701 88.4081 98.4382Z",
    fill: "#196098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.34 108.068C117.123 109.691 116.437 111.646 114.814 112.428C113.185 113.211 111.231 112.525 110.448 110.902C109.666 109.278 110.346 107.324 111.975 106.541C113.598 105.759 115.552 106.439 116.335 108.068H116.34Z",
    fill: "#7BA0AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.614 120.304C122.266 121.66 121.697 123.284 120.341 123.94C118.984 124.592 117.361 124.023 116.704 122.671C116.053 121.315 116.622 119.687 117.973 119.035C119.329 118.384 120.958 118.953 121.609 120.309L121.614 120.304Z",
    fill: "#1A7A9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.558 118.972C106.146 120.192 105.631 121.655 104.411 122.243C103.191 122.831 101.727 122.321 101.139 121.101C100.551 119.881 101.066 118.418 102.282 117.829C103.502 117.241 104.965 117.756 105.553 118.972H105.558Z",
    fill: "#2381A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5623 124.917C88.0825 126.001 87.6304 127.304 86.5464 127.824C85.4623 128.344 84.1596 127.888 83.6394 126.808C83.1193 125.724 83.5714 124.422 84.6554 123.901C85.7394 123.376 87.0422 123.833 87.5623 124.917Z",
    fill: "#2381A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9735 122.092C70.0818 124.396 69.1145 127.162 66.8103 128.275C64.5062 129.384 61.7402 128.416 60.6319 126.112C59.5235 123.808 60.4909 121.042 62.7951 119.934C65.0992 118.825 67.8652 119.793 68.9735 122.092Z",
    fill: "#349FBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.397 140.161C80.9852 141.381 80.4699 142.844 79.2547 143.432C78.0345 144.021 76.5713 143.505 75.9832 142.285C75.395 141.065 75.9102 139.602 77.1255 139.014C78.3456 138.426 79.8088 138.936 80.397 140.156V140.161Z",
    fill: "#146C97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.7326 148.161C67.5832 149.921 66.8395 152.036 65.0798 152.886C63.3201 153.737 61.2006 152.993 60.3548 151.233C59.5041 149.474 60.243 147.354 62.0076 146.509C63.7673 145.658 65.8867 146.402 66.7326 148.161Z",
    fill: "#212C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9776 157.923C79.5317 159.075 79.0505 160.461 77.8984 161.015C76.7463 161.569 75.3658 161.083 74.8068 159.931C74.2526 158.779 74.7338 157.398 75.8859 156.839C77.038 156.285 78.4234 156.766 78.9776 157.919V157.923Z",
    fill: "#146C97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9249 168.365C76.6735 169.921 76.0221 171.792 74.4617 172.546C72.9013 173.294 71.0298 172.643 70.2812 171.083C69.5277 169.522 70.184 167.651 71.7444 166.902C73.3048 166.154 75.1715 166.805 75.9249 168.365Z",
    fill: "#2381A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.895 172.274C86.4151 173.358 85.9631 174.66 84.879 175.181C83.795 175.701 82.4923 175.249 81.9721 174.165C81.4471 173.081 81.9041 171.778 82.9881 171.253C84.0721 170.733 85.3749 171.185 85.895 172.269V172.274Z",
    fill: "#7BA0AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4755 199.183C78.3894 201.079 77.5922 203.359 75.6964 204.273C73.8005 205.187 71.5207 204.389 70.6068 202.494C69.6929 200.598 70.4901 198.318 72.386 197.404C74.2818 196.49 76.5616 197.287 77.4755 199.183Z",
    fill: "#7BA0AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.619 181.505C101.271 182.861 100.702 184.49 99.3456 185.141C97.9894 185.793 96.3609 185.224 95.7095 183.873C95.0581 182.516 95.6269 180.888 96.9831 180.236C98.3394 179.585 99.9678 180.154 100.619 181.51V181.505Z",
    fill: "#2381A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.316 188.11C110.152 189.845 109.423 191.93 107.687 192.767C105.952 193.603 103.866 192.874 103.03 191.138C102.194 189.403 102.923 187.317 104.659 186.481C106.394 185.645 108.48 186.374 109.316 188.11Z",
    fill: "#196098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.131 182.953C116.622 183.969 116.194 185.189 115.178 185.68C114.162 186.171 112.942 185.743 112.451 184.728C111.96 183.712 112.388 182.491 113.404 182C114.42 181.509 115.64 181.937 116.131 182.953Z",
    fill: "#212C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.129 196.719C132.683 197.871 132.197 199.252 131.05 199.811C129.897 200.365 128.517 199.879 127.963 198.732C127.409 197.58 127.89 196.199 129.042 195.64C130.194 195.086 131.575 195.567 132.134 196.719H132.129Z",
    fill: "#2381A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.166 162.367L145.555 157.754L126.597 158.08L145.166 162.367Z",
    fill: "url(#paint18_radial_338_676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.555 157.752C146.829 157.859 147.772 158.977 147.665 160.256C147.558 161.529 146.44 162.472 145.166 162.366C143.893 162.259 142.945 161.136 143.056 159.867C143.163 158.593 144.281 157.645 145.56 157.752H145.555Z",
    fill: "#7BA0AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.4 175.744C131.92 176.828 131.468 178.131 130.384 178.651C129.3 179.176 127.997 178.719 127.477 177.635C126.952 176.551 127.409 175.248 128.493 174.723C129.577 174.203 130.879 174.655 131.4 175.744Z",
    fill: "#146C97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.332 173.701C150.406 175.69 149.663 178.164 147.679 179.238C145.696 180.312 143.217 179.569 142.143 177.585C141.073 175.602 141.812 173.123 143.795 172.049C145.779 170.979 148.258 171.718 149.332 173.701Z",
    fill: "#7BA0AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.411 102.983L146.347 97.2129L115.154 140.277L153.411 102.983Z",
    fill: "url(#paint19_radial_338_676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.39 134.331L133.456 130.486L122.766 139.513L135.39 134.331Z",
    fill: "url(#paint20_radial_338_676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.758 142.878L143.013 136.656L125.182 144.701L144.758 142.878Z",
    fill: "url(#paint21_radial_338_676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.757 147.043L129.601 151.36L141.661 151.744L140.757 147.043Z",
    fill: "url(#paint22_radial_338_676)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.429 142.765C143.698 143.349 141.827 142.42 141.243 140.69C140.66 138.959 141.588 137.088 143.319 136.504C145.049 135.921 146.921 136.85 147.504 138.575C148.088 140.306 147.159 142.177 145.429 142.761V142.765Z",
    fill: "#228BB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.813 151.39C141.666 152.11 140.154 151.764 139.435 150.617C138.715 149.47 139.061 147.958 140.208 147.239C141.355 146.519 142.867 146.864 143.586 148.012C144.306 149.159 143.961 150.671 142.813 151.39Z",
    fill: "#196098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.391 134.332C134.253 134.716 133.013 134.103 132.629 132.966C132.245 131.823 132.858 130.588 134 130.204C135.138 129.82 136.377 130.433 136.761 131.57C137.145 132.708 136.533 133.948 135.391 134.332Z",
    fill: "#2381A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.729 104.018C149.303 104.835 146.678 103.532 145.861 101.111C145.045 98.6902 146.347 96.0604 148.768 95.2437C151.189 94.427 153.819 95.7298 154.636 98.1506C155.452 100.576 154.149 103.201 151.729 104.018Z",
    fill: "#212C5E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_338_676",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.9023 144.441) rotate(-28.36) scale(51.8143 51.8143)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#95CCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#91C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#86C0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#75B2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5B9EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#3B85A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#14658D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#005680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002544"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_338_676",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.544 152.054) rotate(-25.72) scale(39.5741 39.5741)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#95CCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#91C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#86C0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#75B2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5B9EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#3B85A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#14658D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#005680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002544"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_338_676",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(102.883 140.919) rotate(-25.72) scale(64.9976 64.9976)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#95CCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#91C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#86C0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#75B2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5B9EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#3B85A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#14658D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#005680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002544"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_338_676",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.145 152.247) rotate(-25.72) scale(39.7394 39.7394)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#95CCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#91C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#86C0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#75B2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5B9EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#3B85A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#14658D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#005680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002544"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_338_676",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.563 152.508) rotate(-25.72) scale(38.913 38.913)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#95CCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#91C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#86C0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#75B2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5B9EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#3B85A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#14658D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#005680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002544"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_338_676",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.148 135.997) rotate(-25.72) scale(59.4413 59.4414)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#95CCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#91C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#86C0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#75B2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5B9EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#3B85A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#14658D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#005680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002544"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_338_676",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(111.686 147.702) rotate(-25.72) scale(52.8837)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#95CCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#91C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#86C0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#75B2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5B9EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#3B85A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#14658D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#005680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002544"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_338_676",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.345 152.268) rotate(-25.72) scale(39.6033 39.6033)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#95CCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#91C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#86C0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#75B2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5B9EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#3B85A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#14658D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#005680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002544"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_338_676",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.347 152.262) rotate(-25.72) scale(39.8171 39.8171)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#95CCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#91C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#86C0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#75B2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5B9EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#3B85A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#14658D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#005680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002544"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_338_676",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.463 152.513) rotate(-25.72) scale(39.9435 39.9436)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#95CCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#91C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#86C0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#75B2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5B9EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#3B85A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#14658D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#005680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002544"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_338_676",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(128.197 150.795) rotate(-25.72) scale(69.9316 69.9316)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#95CCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#91C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#86C0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#75B2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5B9EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#3B85A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#14658D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#005680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002544"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_338_676",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.391 154.004) rotate(-25.72) scale(42.9769 42.9768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#95CCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#91C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#86C0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#75B2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5B9EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#3B85A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#14658D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#005680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002544"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_338_676",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.319 154.059) rotate(-25.72) scale(49.9088 49.9088)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#95CCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#91C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#86C0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#75B2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5B9EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#3B85A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#14658D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#005680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002544"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_338_676",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.822 151.914) rotate(-25.72) scale(40.104 40.104)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#95CCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#91C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#86C0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#75B2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5B9EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#3B85A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#14658D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#005680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002544"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_338_676",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.806 167.759) rotate(-25.72) scale(71.5795 71.5795)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#95CCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#91C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#86C0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#75B2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5B9EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#3B85A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#14658D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#005680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002544"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_338_676",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.269 151.529) rotate(-25.72) scale(38.3588)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#95CCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#91C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#86C0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#75B2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5B9EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#3B85A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#14658D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#005680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002544"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_338_676",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(107.261 165.163) rotate(-25.72) scale(56.2573)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#95CCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#91C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#86C0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#75B2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5B9EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#3B85A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#14658D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#005680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002544"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_338_676",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(107.933 151.415) rotate(-25.72) scale(39.1901 39.1901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#95CCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#91C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#86C0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#75B2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5B9EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#3B85A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#14658D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#005680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002544"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_338_676",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(106.945 156.611) rotate(-85.18) scale(39.7686 39.7685)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#95CCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#91C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#86C0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#75B2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5B9EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#3B85A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#14658D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#005680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002544"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_338_676",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.6897 172.823) rotate(71.36) scale(81.9822 81.9822)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#95CCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#91C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#86C0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#75B2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5B9EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#3B85A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#14658D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#005680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002544"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_338_676",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(106.021 152.08) rotate(71.36) scale(40.0991 40.0991)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#95CCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#91C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#86C0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#75B2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5B9EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#3B85A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#14658D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#005680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002544"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_338_676",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(106.236 151.654) rotate(71.36) scale(38.5533 38.5533)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#95CCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#91C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#86C0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#75B2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5B9EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#3B85A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#14658D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#005680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002544"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_338_676",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(110.969 157.585) rotate(57.87) scale(38.0818 38.0818)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#E9E9EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#95CCE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#91C9E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#86C0DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#75B2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5B9EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#3B85A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#14658D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#005680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002544"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_338_676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 109.652,
    fill: "white",
    transform: "translate(60 95)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDin);
export default __webpack_public_path__ + "static/media/din.226f71cb7de51ba6fb288cd38663b097.svg";
export { ForwardRef as ReactComponent };